export const jieduan = {
  type: [
    {name: '阶段练习', id: 'phaseTest'},
    {name: '期中', id: 'midOfTermTest'},
    {name: '期末', id: 'endOfTermTest'},
    {name: '专题练习', id: 'topicTest'},
    {name: '开学考试', id: 'beginOfTermTest'},
  ] as {name: string; id: string}[],
  years: [
    {name: '全部', id: 9999},
    {name: '2023', id: 2023},
    {name: '2022', id: 2022},
    {name: '2021', id: 2021},
    {name: '2020', id: 2020},
    {name: '2019', id: 2019},
  ] as {name: string; id: number}[],
};
export const mingxiao = {
  type: [
    {name: '课时练习', id: 'classExercise'},
    {name: '单元测试', id: 'unitExercise'},
    {name: '阶段练习', id: 'phaseExercise'},
    {name: '期中', id: 'midOfTermExercise'},
    {name: '期末', id: 'endOfTermExercise'},
    {name: '专题练习', id: 'topicExercise'},
    {name: '竞赛', id: 'competitionExercise'},
    {name: '开学考试', id: 'beginOfTermExercise'},
    {name: '模拟', id: 'practiceExercise'},
    {name: '学业考试', id: 'academicExercise'},
    {name: '课前预习', id: 'previewExercise'},
  ],
};
export const zhuanti = {
  type: {
    1: [
      {name: '模拟', id: 'practiceTest'},
      {name: '真题', id: 'pastExamTest'},
      {name: '学业考试', id: 'academicTest'},
    ],
    2: [
      {name: '小升初模拟', id: 'practiceTest'},
      {name: '小升初真题', id: 'pastExamTest'},
      {name: '学业考试', id: 'academicTest'},
    ],
    3: [
      {name: '中考模拟', id: 'practiceTest'},
      {name: '中考真题', id: 'pastExamTest'},
      {name: '学业考试', id: 'academicTest'},
    ],
    4: [
      {name: '高考模拟', id: 'practiceTest'},
      {name: '高考真题', id: 'pastExamTest'},
      {name: '学业考试', id: 'academicTest'},
    ],
  },
};
